module.exports = __webpack_public_path__ + "51bec35806185f3c61c4cc31f1d099ef.png";